import UnionPayLogo from "../../../assets/icons/unionPayIcon.svg";
import PaypalLogo from "../../../assets/icons/paypalIcon.svg";
import VisaLogo from "../../../assets/icons/visaIcon.svg";

const BRAND_META = {
  unionpay: {
    key: "unionpay",
    label: "UnionPay",
    icon: UnionPayLogo,
  },
  visa: {
    key: "visa",
    label: "Visa",
    icon: VisaLogo,
  },
  paypal: {
    key: "paypal",
    label: "PayPal",
    icon: PaypalLogo,
  },
};

const normalize = (value) => String(value || "").trim().toLowerCase();

const onlyDigits = (value) => String(value || "").replace(/\D/g, "");

const brandFromText = (value) => {
  const text = normalize(value);
  if (!text) return null;

  if (text.includes("union")) return "unionpay";
  if (text.includes("visa")) return "visa";
  if (text.includes("paypal") || text.includes("pay pal")) return "paypal";

  return null;
};

const brandFromCardNumber = (value) => {
  const digits = onlyDigits(value);
  if (!digits) return null;

  if (/^4/.test(digits)) return "visa";

  if (/^(62|81)/.test(digits)) return "unionpay";

  return null;
};

export const detectCardBrandKey = ({ cardNumber = "", brand = "" } = {}) => {
  return brandFromText(brand) || brandFromCardNumber(cardNumber) || "unionpay";
};

export const getCardBrandMeta = (input) => {
  const key = typeof input === "string"
    ? detectCardBrandKey({ brand: input })
    : detectCardBrandKey(input || {});

  return BRAND_META[key] || BRAND_META.unionpay;
};
